/**
 * 품목코드 체계 (ProductCodeRule) 리듀서.
 *
 * 설정 페이지 "품목코드 체계" 섹션 + 코드체계 편집 모달이 사용하는 룰 목록 상태.
 * 룰 CRUD 후에는 saga 가 GET_PRODUCT_CODE_RULES 재호출로 목록을 갱신한다.
 *
 * todo(backend): 백엔드 미배포 상태에서는 saga 가 조회 실패를 잡아 빈 목록으로 둔다.
 *   배포 후 응답 shape({ items, count }) 가 맞는지 확인.
 */

import * as actions from "../actions";

const initialState = {
  rules: [],
  count: 0,
  status: { isFetching: false, error: null },
};

export default function productCode(state = initialState, action) {
  switch (action.type) {
    case actions.GET_PRODUCT_CODE_RULES:
    case actions.CREATE_OR_UPDATE_PRODUCT_CODE_RULE:
    case actions.DELETE_PRODUCT_CODE_RULE:
      return { ...state, status: { isFetching: true, error: null } };
    case actions.RECEIVE_PRODUCT_CODE_RULES:
      return {
        ...state,
        rules: action.rules || [],
        count: action.count || 0,
        status: { isFetching: false, error: null },
      };
    case actions.SET_PRODUCT_CODE_RULES_FAILURE:
      return {
        ...state,
        status: { isFetching: false, error: action.error },
      };
    default:
      return state;
  }
}
